"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bold = void 0;
var FontData_js_1 = require("../../FontData.js");
var bold_js_1 = require("../../../common/fonts/tex/bold.js");
exports.bold = (0, FontData_js_1.AddCSS)(bold_js_1.bold, {
    0xB7: { c: '\\22C5' },
    0x131: { f: '' },
    0x237: { f: '' },
    0x2B9: { c: '\\2032' },
    0x2002: { c: '' },
    0x2003: { c: '' },
    0x2004: { c: '' },
    0x2005: { c: '' },
    0x2006: { c: '' },
    0x2009: { c: '' },
    0x200A: { c: '' },
    0x2015: { c: '\\2014' },
    0x2016: { c: '\\2225' },
    0x2017: { c: '_' },
    0x2022: { c: '\\2219' },
    0x2033: { c: '\\2032\\2032' },
    0x2034: { c: '\\2032\\2032\\2032' },
    0x203E: { c: '\\2C9' },
    0x2044: { c: '/' },
    0x2057: { c: '\\2032\\2032\\2032\\2032' },
    0x20D7: { c: '\\2192', f: 'VB' },
    0x219A: { c: '\\2190\\338' },
    0x219B: { c: '\\2192\\338' },
    0x21AE: { c: '\\2194\\338' },
    0x21CD: { c: '\\21D0\\338' },
    0x21CE: { c: '\\21D4\\338' },
    0x21CF: { c: '\\21D2\\338' },
    0x2204: { c: '\\2203\\338' },
    0x2206: { c: '\\394' },
    0x220C: { c: '\\220B\\338' },
    0x2224: { c: '\\2223\\338' },
    0x2226: { c: '\\2225\\338' },
    0x2241: { c: '\\223C\\338' },
    0x2244: { c: '\\2243\\338' },
    0x2247: { c: '\\2245\\338' },
    0x2249: { c: '\\2248\\338' },
    0x2262: { c: '\\2261\\338' },
    0x226D: { c: '\\224D\\338' },
    0x226E: { c: '<\\338' },
    0x226F: { c: '>\\338' },
    0x2270: { c: '\\2264\\338' },
    0x2271: { c: '\\2265\\338' },
    0x2280: { c: '\\227A\\338' },
    0x2281: { c: '\\227B\\338' },
    0x2284: { c: '\\2282\\338' },
    0x2285: { c: '\\2283\\338' },
    0x2288: { c: '\\2286\\338' },
    0x2289: { c: '\\2287\\338' },
    0x22AC: { c: '\\22A2\\338' },
    0x22AD: { c: '\\22A8\\338' },
    0x22E2: { c: '\\2291\\338' },
    0x22E3: { c: '\\2292\\338' },
    0x2329: { c: '\\27E8' },
    0x232A: { c: '\\27E9' },
    0x25B5: { c: '\\25B3' },
    0x25BF: { c: '\\25BD' },
    0x2758: { c: '\\2223' },
    0x29F8: { c: '/', f: 'BI' },
    0x2A2F: { c: '\\D7' },
    0x3008: { c: '\\27E8' },
    0x3009: { c: '\\27E9' },
});
//# sourceMappingURL=bold.js.map